import { render, staticRenderFns } from "./stake-dialog.vue?vue&type=template&id=ae411da0&scoped=true&"
import script from "./stake-dialog.vue?vue&type=script&lang=ts&"
export * from "./stake-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./stake-dialog.vue?vue&type=style&index=0&id=ae411da0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae411da0",
  null
  
)

export default component.exports